import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field, change, formValueSelector} from 'redux-form';
import {InputField, DropdownField} from '../../../../common/components/form';
import {toFloat} from '../../../../common/util/fieldsNormalization';
import {Card, Grid, Dropdown, Icon} from 'semantic-ui-react';
import {getLimitedOptions} from './helper';
import {findIndex} from 'lodash';
import './editProductData.scss';
import {requiredSelect} from '../../../utils';
import {MASTER_VEHICLE_FORM} from '../../../../common/forms';

class SalesData extends Component {
  render() {
    const {addSales, jdeList, price, aditionalsArray, iva, ice, salesDate} = this.props;
    console.log(salesDate);
    return (
      <div>
        <Card raised fluid className='vehicle-master-form'>
          <Grid textAlign='left'>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Porcentaje ICE Fijo%</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='ice'
                  component={InputField}
                  type='Number'
                  normalize={toFloat}
                  min="0.00" step="0.01" pattern='^\d+(?:\.\d{1,2})?$'
                  disabled={!addSales}
                  invalidMessage='Por favor, llene este campo siguiendo el formato 0.00 y el valor mínimo debe ser 0.01'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Porcentaje ICE Variable%</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='variableIce'
                  component={InputField}
                  type='Number'
                  normalize={toFloat}
                  min="0.00" step="0.01" pattern='^\d+(?:\.\d{1,2})?$'
                  disabled={!addSales}
                  invalidMessage='Por favor, llene este campo siguiendo el formato 0.00 y el valor mínimo debe ser 0.01'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Porcentaje IVA%</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='iva'
                  component={InputField}
                  type='number'
                  normalize={toFloat}
                  min="0.00" step="0.01" pattern='^\d+(?:\.\d{1,2})?$'
                  disabled={!addSales}
                  invalidMessage='Por favor, llene este campo siguiendo el formato 0.00 y el valor mínimo debe ser 0.00'
                  required
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Precio Venta</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='salesPrice'
                  component={InputField}
                  type='number'
                  normalize={toFloat}
                  min="0.01" step="0.01" pattern='^\d+(?:\.\d{1,2})?$'
                  disabled={!addSales}
                  invalidMessage='Por favor, llene este campo siguiendo el formato 0.00 y el valor mínimo debe ser 0.01'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Facturación con IVA</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='ivaInvoicing'
                  options={getLimitedOptions(jdeList.ivaInvoicingList, 'completeName', 20)}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addSales}
                  required
                />
              </Grid.Column>

              <Grid.Column width={2}>
                <h4>Nombre Comercial</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='vehicleId'
                  options={this.getModels()}
                  component={this.renderDropdownVehicleList}
                  disabled={!addSales}
                  required
                  validate= {[requiredSelect]}
                  invalidMessage='Por favor, Seleccione un una opción'
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column with={2}>
                <h4>Fecha Act Precio</h4>
              </Grid.Column>
              <Grid.Column with={3}>
                <h4>{salesDate}</h4>
              </Grid.Column>
              <Grid.Column with={3}>
              </Grid.Column>
              <Grid.Column with={2}>
              </Grid.Column>
              <Grid.Column with={3}>
              </Grid.Column>
              <Grid.Column with={2}>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Card raised fluid className='vehicle-master-form'>
          <Grid textAlign='left'>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Base Imponible:</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <h4>{(price / ((1 + iva / 100) * (1 + ice / 100))).toFixed(2)} menor a 40000</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                {this.renderCheckPrice()}
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Número de Elementos de Seguridad:</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <h4>{aditionalsArray.length}</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                {this.renderCheckAditonals()}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Valor ICE:</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <h4>{((price / ((1 + iva / 100) * (1 + ice / 100)) * (ice / 100))).toFixed(2)} </h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <h4>Valor Descuento:</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <h4>{this.getDiscountIce()}</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Valor a Pagar:</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <h4>{this.getIce()}</h4>
              </Grid.Column>
              <Grid.Column width={3}>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
      </div>
      
    );
  }

  getIce() {
    const {price, aditionalsArray, iva, ice} = this.props;
    const iceCalculate = ((price / ((1 + iva / 100) * (1 + ice / 100)) * (ice / 100))).toFixed(2);
    const bi = (price / ((1 + iva / 100) * (1 + ice / 100))).toFixed(2);
    if (bi < 40000 && aditionalsArray.length >= 3) {
      return (iceCalculate - (iceCalculate * 0.15)).toFixed(2);
    }
    return iceCalculate;
  }

  getDiscountIce() {
    const {price, aditionalsArray, iva, ice} = this.props;
    const iceCalculate = ((price / ((1 + iva / 100) * (1 + ice / 100)) * (ice / 100))).toFixed(2);
    const bi = (price / ((1 + iva / 100) * (1 + ice / 100))).toFixed(2);
    if (bi < 40000 && aditionalsArray.length >= 3) {
      return (iceCalculate * 0.15).toFixed(2);
    }
    return 0;
  }

  renderCheckAditonals = () => {
    const {aditionalsArray} = this.props;
    if (aditionalsArray.length >= 3) {
      return (
        <>
          <Icon name='check' circular inverted color='green' size='large' />
        </>
      );
    }
    return (
      <div id='mad-failed'>
        <Icon name='close' circular inverted color='red' size='large' />
      </div>
    );
  }
  
  renderCheckPrice = () => {
    const {price, iva, ice} = this.props;
    const bi = (price / ((1 + iva / 100) * (1 + ice / 100))).toFixed(2);
    if (bi <= 40000) {
      return (
        <>
          <Icon name='check' circular inverted color='green' size='large' />
        </>
      );
    }
    return (
      <div id='mad-failed'>
        <Icon name='close' circular inverted color='red' size='large' />
      </div>
    );
  }
  getModels() {
    const {vehiclesModelsList} = this.props;
    return vehiclesModelsList.map((model) => {
      return {'text': model.name, 'value': model.id};
    });
  }

  getModelName(modelId) {
    if (!modelId) {
      return '';
    }
    const {vehiclesModelsList} = this.props;
    const index = findIndex(vehiclesModelsList, {'id': modelId});
    if (index === -1) {
      return '';
    }
    return vehiclesModelsList[index].name;
  }

  renderDropdownVehicleList = (field) => {
    const {meta} = field;
    return (
      <div>
        <Dropdown selection
          options={field.options}
          value={field.input.value}
          search
          onChange={(e, data) => {
            const modelName = this.getModelName(data.value);
            this.props.change('masterVehicle', 'vehicleName', modelName);
            return field.input.onChange(data.value);
          }}
          placeholder='Seleccione una opción'
          style={!field.input.value && field.required ? {'borderColor': 'red', 'backgroundColor': '#fff5f6'} : null}
          disabled={field.disabled}
          required
        />
        {meta.touched && (meta.error && <span className='error-message'>Valor requerido</span>)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const formValues = formValueSelector(MASTER_VEHICLE_FORM.name);
  const price = formValues(state, 'salesPrice');
  const aditionalsArray = formValues(state, 'aditionals');
  const ice = formValues(state, 'ice');
  const iva = formValues(state, 'iva');
  const salesDate = formValues(state, 'salesDate');
  return {
    'jdeList': state.masterVehicle.jdeList,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'vehiclesModelsList': state.vehiclesModels.vehicles,
    price,
    aditionalsArray,
    ice,
    iva,
    salesDate,
  };
};

export default connect(mapStateToProps, {change})(SalesData);
